import { createId } from '@prompt-optimize/shared'
import type { PromptDocument, Section, Tag } from '../types'

/**
 * Convenience helper to build a Section declaratively.
 */
export function buildSection(
  title: string,
  order: number,
  tagStrings: string[] = [],
): Section {
  const tags: Tag[] = tagStrings.map(raw => ({ id: createId(), raw }))
  return {
    id: createId(),
    title,
    type: 'tags',
    tags,
    enabled: true,
    order,
  }
}

export function buildBuiltinScheme(
  meta: { id: string, name: string },
  sections: Section[],
  params: PromptDocument['params'] = {},
): PromptDocument {
  return {
    id: meta.id,
    name: meta.name,
    schemaVersion: 1,
    sections,
    params,
    updatedAt: 0,
    starred: true,
  }
}
